export var GET_SERVICE_PROPERTIES = 'GET_SERVICE_PROPERTIES';
export var GET_SERVICE_PROPERTIES_SUCCESS = 'GET_SERVICE_PROPERTIES_SUCCESS';
export var getServiceProperties = function (payload) { return ({
    type: GET_SERVICE_PROPERTIES,
    payload: payload
}); };
export var getServicePropertiesSuccess = function (payload) { return ({
    type: GET_SERVICE_PROPERTIES_SUCCESS,
    payload: payload
}); };
